import React, {useEffect, useRef, useState} from 'react';
import $api, {API_URL} from "../http";
import "../css/personal-data.css"
import ModalDialog from "./ModalDialog";

const UnhandledViewer = ({store, merchants}) => {



    const [filter, setFilter] = useState({})
    const [requests, setRequests] = useState([])
    const [skipCounter, setSkipCounter] = useState(0)
    const [fetching, setFetching] = useState(true)
    const [stopFetching, setStopFetching] = useState(false)

    const [processing, setProcessing] = useState(false)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(true)

    const startSearchTimer = useRef()

    const [activeCauseModal, setActiveCauseModal] = useState("no")
    const [activeCauseViewModal, setActiveCauseViewModal] = useState("no")
    const [cardId, setCardId] = useState()
    const [requestId, setRequestId] = useState()
    const [modalMessage, setModalMessage] = useState("")
    const [dataToShowInModal, setDataToShowInModal] = useState(null)



    const [cards, setCards] = useState([])


    const getCards = async (filter) => {

        setLoading(true)

        filter = filter ? encodeURIComponent(JSON.stringify(filter)) : ""

        const response = await $api.get(`/get_cards?filter=${filter}`)
        console.log(response.data)



        const cardOptions = response.data.map(card => ({
            label: `${card.cardholder} • ${card.bank} • ${card.number.slice(-4)} • ${card.user?.login || ""}`, // То, что будет видно
            value: card._id, // То, что будет использоваться как "ключ"
            original: card // можно сохранить оригинальный объект, если нужно
        }));


        setCards(cardOptions)

        setLoading(false)

        setSuccess(true)
        setTimeout(() => {
            setSuccess(false)
        }, 1500)
    }




    const searchForCauses = async (requestId, cardId) => {


        try {

            const response = await $api.get(`/search_fail_conditions?cardId=${cardId}&requestId=${requestId}`)

            console.log(response.data)


            if(response.data.result === "OK") {


                const failingConditions = response.data.failingConditions

                setModalMessage(response.data.message)

                const divElement = (
                    <div className={"data-to-show-in-modal"}>



                        {failingConditions.map((condition, index) => {

                            return (
                                <div
                                    key={Math.random()}
                                    className={"data-to-show-in-modal-piece"}
                                >
                                    <strong
                                        style={{"marginRight": "5px"}}
                                    >{index + 1}. {condition.message} </strong>
                                    {/*{value !== "any"*/}
                                    {/*    ?*/}
                                    {/*    value || "не указано"*/}
                                    {/*    :*/}
                                    {/*    trafficOptions.find(item => item.value === value).label*/}
                                    {/*}*/}
                                </div>
                            )})}
                    </div>
                );


                setDataToShowInModal(divElement)

                setActiveCauseViewModal("progress")
                setTimeout(() => {
                    setActiveCauseViewModal("active")
                }, 100)


            } else {

                setDataToShowInModal("")
                setModalMessage(response.data.message)

                setActiveCauseViewModal("progress")
                setTimeout(() => {
                    setActiveCauseViewModal("active")
                }, 100)
            }

        } catch (e) {
            setModalMessage(e.message)

            setActiveCauseViewModal("progress")
            setTimeout(() => {
                setActiveCauseViewModal("active")
            }, 100)
        }





    }


    const getUnhandledRequests = async (filter, skip) => {

        setFetching(false)
        setLoading(true)


        const response = await $api.get(`/get_unhandled_requests?filter=${encodeURIComponent( JSON.stringify(filter) )}&skip=${skip}`)
        console.log(response.data)
        setProcessing(false)
        if(response.data.stopFetching) {
            setStopFetching(true)
            setSkipCounter(0)
        }
        // setSkipCounter(prev => prev + response.data.requests.length)
        setRequests(prev => [...prev, ...response.data.requests])
        setLoading(false)

    }


    useEffect(() => {
        getCards({onlyActive: true})
    }, [])


    useEffect(() => {
        store.setPageTitle("Невыдачи")


        console.log("effect unhandled filter")
        console.log(fetching, !stopFetching)

        if(fetching && !stopFetching) {

            clearTimeout(startSearchTimer.current)

            startSearchTimer.current = setTimeout(() => {
                getUnhandledRequests(filter, skipCounter)
            }, 1500)
        }


    }, [fetching, skipCounter, stopFetching, filter]);




    return (
        <div className={"card-viewer-wrapper"}>
            <div className={"order-viewer-merchant-sort-wrapper"}>
                <select
                    value={filter.merchant}
                    onChange={(e) => {
                        setLoading(true)
                        setFilter(prev => ({
                            ...prev,
                            merchant: e.target.value
                        }))

                        setRequests([])

                        setSkipCounter(0)

                        setTimeout(() => {
                            setStopFetching(false)
                            setFetching(true)
                        }, 1000)
                    }}
                >
                    <option value={""}>Все</option>
                    {merchants.sort((a, b) => a.login.localeCompare(b.login)).map(merchant => <option id={merchant._id}
                                                       value={merchant._id}>{merchant.login}</option>)}
                </select>

                <select
                    value={filter.trafficType}
                    onChange={(e) => {
                        setLoading(true)
                        setRequests([])
                        setFilter(prev => {

                            const newState = {
                                ...prev,
                                trafficType: e.target.value,

                            }
                            return newState
                        })

                        setTimeout(() => {
                            setStopFetching(false)
                            setFetching(true)
                        }, 1000)
                    }}
                >
                    <option value={""}>Все типы трафика</option>
                    <option value={"card_number"}>По номеру карты</option>
                    <option value={"sbp"}>СБП</option>
                    <option value={"nspk"}>НСПК</option>
                </select>

                <input
                    type={"number"}
                    placeholder={"По сумме"}
                    value={filter.amount}
                    onChange={(e) => {
                        setLoading(true)
                        setRequests([])
                        setFilter(prev => {
                            return {
                                ...prev,
                                amount: parseFloat(e.target.value)
                            }
                        })


                        setSkipCounter(0)

                        setTimeout(() => {
                            setStopFetching(false)
                            setFetching(true)
                        }, 1000)
                    }}
                />
                <button
                    className={"gradient-dark-button"}
                    onClick={() => {
                        setLoading(true)

                        setFilter({merchant: "", amount: "", trafficType: ""})
                        setTimeout(() => {
                            setFilter({})
                        }, 500)


                        setRequests([])

                        setSkipCounter(0)

                        setTimeout(() => {
                            setStopFetching(false)
                            setFetching(true)
                        }, 1000)
                    }}
                >Сброс
                </button>

                {loading
                    ?
                    <img src={require('../img/loading.gif')} height={"30px"}
                         className={"margin-left-20"}/>
                    :
                    null}

            </div>

            <div style={{overflowX: 'auto', width: '100%' }}>
            <table className="transaction-table">
                <thead>
                <tr>
                    <th>Дата</th>
                    <th>Мерчант</th>
                    <th>Сумма</th>
                    <th>Тип трафика</th>
                    <th>Банк</th>
                    <th>Причины</th>
                    {/*<th>Актуальная сумма</th>*/}
                    {/*<th>Чек</th>*/}

                    {/*<th className={"fixed-table-width"}>Управление</th>*/}

                </tr>
                </thead>
                <tbody>
                {requests.length
                    ?
                    requests?.map((request, index) => {
                        // const formattedDate = new Date(card.block_timestamp)
                        //     .toLocaleString('ru-RU', options);

                        return (
                            <tr
                                key={request._id}
                                className={
                                    index % 2 === 0
                                        ?
                                        'even-row'
                                        :
                                        'odd-row'
                                }
                            >
                                <td>{new Date(request.openDate).toLocaleString([], {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}</td>
                                <td>{request.merchantLogin}</td>
                                <td>{request.amount}</td>
                                {/*<td>{request.merchant?.login}</td>*/}
                                {/*<td>{request.trader?.login}</td>*/}
                                <td>{request.trafficType}</td>
                                <td>{request.bankCode}</td>
                                <td>
                                    <button
                                        className={"gradient-orange-button"}
                                        onClick={() => {
                                            setRequestId(request._id)
                                            setCardId("")
                                            setActiveCauseModal("progress")
                                            setTimeout(() => {
                                                setActiveCauseModal("active")
                                            }, 100)
                                            setModalMessage(`Для какой карты проверяем эту невыдачу?`)
                                        }}
                                    >Найти</button>
                                </td>

                            </tr>
                        );
                    })
                    :
                    null
                }
                </tbody>


            </table>
            </div>
            <ModalDialog
                active={activeCauseModal}
                setActive={setActiveCauseModal}
                purpose={"fail_search"}
                inputPlaceHolder={"ID реквизитов"}
                inputValue={cardId}
                setInputValue={setCardId}
                activeCards={cards}
                message={modalMessage}
                buttonText1={"GO"}
                processing={processing}
                success={success}
                action2={() =>  getCards({onlyActive: true})}
                action={() => {
                    searchForCauses(requestId, cardId)
                    // setActivePayoffConfirmModal("progress")
                    // setTimeout(() => {
                    //     setActivePayoffConfirmModal("active")
                    // }, 100)
                    // setModalMessage(`Подтверждаете выплату для ${trader.login}?`)
                }}

            />

            <ModalDialog
                active={activeCauseViewModal}
                setActive={setActiveCauseViewModal}

                dataToShow={dataToShowInModal}
                message={modalMessage}
                purpose={"info"}
                buttonText2={"OK"}
            />

        </div>
    );
};

export default UnhandledViewer;